import { isDatePastOrEqual } from '@goodneighbor/utilities/date/index';

export const isExternalEvent = (event: { source?: string } | null) =>
  event?.source === 'EXTERNAL';

export const getIsEventFull = (
  event: { source?: string; overallCapacity?: number | null } | null,
  registrationCount: number
): boolean => {
  if (isExternalEvent(event)) return false;
  const capacity = event?.overallCapacity ?? 0;
  return capacity > 0 && registrationCount >= capacity;
};

export const getIsEventPast = (
  event: { endsAt?: string | null } | null
): boolean => {
  return event?.endsAt ? isDatePastOrEqual(new Date(event.endsAt)) : false;
};

type RegisterButtonState = {
  isAlreadyRegistered: boolean;
  isEventFull: boolean;
  isEventPast: boolean;
};

export const getRegisterButtonLabel = ({
  isAlreadyRegistered,
  isEventFull,
  isEventPast
}: RegisterButtonState): string => {
  if (isAlreadyRegistered) return 'Registered';
  if (isEventFull || isEventPast) return 'Registration closed';
  return 'Register Now';
};

export const isRegisterButtonDisabled = ({
  isAlreadyRegistered,
  isEventFull,
  isEventPast
}: RegisterButtonState): boolean =>
  isAlreadyRegistered || isEventFull || isEventPast;
